import { render, staticRenderFns } from "./ProductListing.vue?vue&type=template&id=06b969f6&scoped=true&"
import script from "./ProductListing.vue?vue&type=script&lang=js&"
export * from "./ProductListing.vue?vue&type=script&lang=js&"
import style0 from "./ProductListing.vue?vue&type=style&index=0&id=06b969f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b969f6",
  null
  
)

export default component.exports